import { Link, useParams } from 'react-router-dom';
import { MarketingArticle } from '../components/marketing/MarketingArticle';
import { MarketingLandingShell } from '../components/marketing/MarketingLandingShell';
import { PageSeo } from '../components/seo/PageSeo';
import { JsonLd } from '../components/seo/JsonLd';
import { NOT_FOUND_META } from '../lib/seo';
import { COMPARISONS } from '../content/comparisons';
import { buildMarketingPageSchema } from '../lib/schema';

export function ComparisonPage() {
  const { slug } = useParams();
  const comparison = slug ? COMPARISONS[slug] : undefined;
  if (!comparison) return <PageSeo meta={NOT_FOUND_META} />;

  return (
    <MarketingLandingShell pageClassName="page-comparison">
      <PageSeo meta={comparison.meta} />
      <JsonLd data={buildMarketingPageSchema(comparison.heading, comparison.meta.path, comparison.meta.description)} />
      <MarketingArticle
        title={comparison.heading}
        lede={comparison.intro}
        sections={[
          { id: 'induce-workflow', title: 'The Induce workflow', body: 'Start with a screenplay or brief. Induce plans the shots, generates them through its model pipeline, and checks each result against the story before it enters the cut.' },
          { id: 'choose-your-workflow', title: 'Choose the workflow that fits', body: `For projects that depend on scene-to-scene continuity and a finished cut, explore Induce for ${comparison.audience}. Compare the tools against your own requirements for shot control, delivery, and rights before choosing.` },
        ]}
        relatedLinks={[
          { label: `Induce for ${comparison.audience}`, to: `/for-${comparison.audience}` },
          { label: 'See pricing', to: '/pricing' },
        ]}
      >
        <Link to="/what-is-induce" className="text-primary">Learn how Induce works</Link>
      </MarketingArticle>
    </MarketingLandingShell>
  );
}
